import Idle from "slotworks/state-machine/standard/states/idle";
import gameState from "slotworks/model/game-state";
import BonusRecord from "integration/revolver/schema/bonus-record";
import soundManager from "slotworks/sound/sound-manager";
import RevolverSettings from "model/revolver-settings";
import Timer from "slotworks/utils/timer";

export default class ICIdle extends Idle {

    private timer: number;

    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord();
        if(record instanceof BonusRecord) {
            gameState.getCurrentGame().previousRecord();
        }

        const time = Date.now() - RevolverSettings.lastWinTime;
        if(RevolverSettings.winCount == 0 || time > 10000) {
            soundManager.customEvent("base_music");
            RevolverSettings.winCount = 0;
        } else {
            this.timer = Timer.setTimeout(() => {
                soundManager.customEvent("base_music");
                RevolverSettings.winCount = 0;
            }, 10000 - time);
        }
        super.onEnter();
    }

    public onExit() {
        Timer.clearTimeout(this.timer);
        super.onExit();
    }
}